module.exports = __webpack_public_path__ + "img/chr_ts_18.bd12b587.png";